import { SceneWrapper } from '~/components';
import { type FormikProps, isEmpty, useFormikContext } from '~/modules';
import type { OnboardingPhoneFormValues } from './schema';
import { ButtonComponent, Input } from './styles';

const OnboardingPhone = () => {
  const {
    values,
    errors,
    setFieldValue,
    submitForm,
    isValid,
    touched,
  }: FormikProps<OnboardingPhoneFormValues> = useFormikContext();
  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          id="phone-onboarding"
          onPress={submitForm}
          disabled={!isValid || isEmpty(values.mobilePhone)}
          fullWidth
        >
          AVANÇAR
        </ButtonComponent>
      }
    >
      <Input
        name="mobilePhone"
        id="mobilePhone"
        autoFocus
        value={values.mobilePhone}
        onChange={(e) => {
          setFieldValue('mobilePhone', e.target.value);
        }}
        label="Número de celular"
        errors={touched?.mobilePhone && errors?.mobilePhone}
        maskType="cellphone"
        inputMode="numeric"
        inputProps={{ inputMode: 'numeric' }}
      />
    </SceneWrapper>
  );
};

export default OnboardingPhone;
